import { render, staticRenderFns } from "./systemRelease.vue?vue&type=template&id=e55f749e&scoped=true&"
import script from "./systemRelease.vue?vue&type=script&lang=js&"
export * from "./systemRelease.vue?vue&type=script&lang=js&"
import style0 from "./systemRelease.vue?vue&type=style&index=0&id=e55f749e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e55f749e",
  null
  
)

export default component.exports